import  Swal  from 'sweetalert2';

import { QuizService } from '../../../_services/quiz.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-subscription-grouping-modify-subtopic',
  templateUrl: './subscription-grouping-modify-subtopic.component.html',
  styleUrls: ['./subscription-grouping-modify-subtopic.component.css']
})
export class SubscriptionGroupingModifySubtopicComponent implements OnInit {
  @Input() topic={topics:[],name:"", hasTemplates:false,subtopics:[],selectedSubTopics:[],isSelected:false}
  @Input() subscriptionGrouping:Object=undefined
  @Input() selectedSubTopicCount=0
  @Input() tCount=0
  @Input() tLength=0
  subTopicIds=[]
  previousCount=0
  emitCounter=0
  @Output() renderMathRequest = new EventEmitter<boolean>()
  flashMessage=""

  category:string="subtopic"
  constructor(
    private quizService:QuizService) { }

  ngOnInit(): void {
    for(let x  of this.topic.subtopics){
      this.subTopicIds.push(x['id'])
    }
  }
  updateQuizAreaItem(subTopicId:number){

    if(this.subscriptionGrouping){
     let x= this.quizService.updateGroupingQuizAreaItem(this.subscriptionGrouping['server_subscription_grouping_id'],subTopicId,this.category).subscribe(
      data=>{
        if(data.topicSubTopicId!=0){

        }
        }
     )

    }
  }
  ngAfterViewInit(){

    if((this.tCount==(this.tLength-1))){
      this.renderMathRequest.emit(true)

    }


  }

  alertOneSubtopic(){
    Swal.fire("Oops",this.flashMessage,'info')
  }

}
